import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CardsComponent } from './cards.component';
import { SlickModule } from 'ngx-slick';
import { SharedModule } from './../../shared/shared.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule, MatCheckboxModule, MatListModule,
	MatRadioModule, MatSelectModule, MatProgressSpinnerModule, MatNativeDateModule } from '@angular/material';
import { CardsService } from './cards.service';
import { ListCardsComponent } from './list-cards/list-cards.component';
import { DataCardsComponent } from './data-cards/data-cards.component';
import { ConfirmationComponent } from './confirmation/confirmation.component';
import { ChangePassComponent } from './change-pass/change-pass.component';

@NgModule({
	imports: [
		CommonModule,
		SharedModule,
		FormsModule,
		ReactiveFormsModule,
		MatCheckboxModule,
		MatButtonModule,
		MatNativeDateModule,
		MatProgressSpinnerModule,
		SlickModule.forRoot()
	],
	declarations: [
		CardsComponent,
		ListCardsComponent,
		DataCardsComponent,
		ConfirmationComponent,
		ChangePassComponent
	],
	exports: [
		CardsComponent,
		ListCardsComponent,
		DataCardsComponent,
		ChangePassComponent
	],
	providers: [
		CardsService,
	]
})
export class CardsModule { }



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/cards/cards.module.ts